<template>
  <NavBar v-if="appStatus.user" />
<!--   <transition name="fade" mode="out-in">  -->
      <router-view></router-view>
<!--   </transition> -->
</template>

<script>
import axios from 'axios';
import { sha512 } from 'js-sha512';
import NavBar from './components/NavBar.vue';
export default {
  name: 'App',
  components:{
    NavBar
  },
  data(){
    return{
      appStatus:{
        version: "1.1.0 | Botanisk",
        //api: "http://localhost:8000",
        api: "api",
        user: false,
        userIp: "",
        ipOk: true,
        userId: "",
        userName: "",
        userMail: "",
        userPass: "",
        userCompany: "",
        userImage: "",
        userKey: "",
        db: "admin_botanisk_be",
        pagesPage: "nieuws",
        customerStats: false,
        salted: "Devenox*16112022",
      },
      settings: {
        website: "https://www.botanisk.be",
        projects: "false",
        nieuws: "true",
        vacatures: "true",
        openingsuren: "true",
        downloads: "true",
        media: "true"
      },
      notification: {
        status: false
      },
      user:{
        status: false
      },
    }
  },
  provide(){
    return{
      status: this.appStatus,
      data: this.appData,
      notification: this.notification,
      user: this.user,
      appSettings: this.settings
    }
  },
  async created(){
    if(localStorage.DevUser){
      await this.localStorageCheck();
    } else if(sessionStorage.DevUser){
      await this.sessionStorageCheck()
    } else if(!this.appStatus.user){
      this.$router.push('/login');
    }
  },
    methods:{
      async localStorageCheck(){
          let data = {mail: 0, password: 0};
          await axios.get(this.appStatus.api + '/get/login.php',{ 
              params:{ 
                  mail: localStorage.DevUserMail, 
                  password: sha512(localStorage.DevUserPass + this.appStatus.salted),
              }
              }).then(function(response){
                  if(response.data.length === 1){
                      data = response.data[0];
                  }
              }).catch(function(error){ 
                  console.log(error);
              });
          if(localStorage.DevUserMail === data.mail && sha512(localStorage.DevUserPass + this.appStatus.salted) === data.password){
              this.appStatus.user = true;
              this.appStatus.db = data.db;
              this.appStatus.userId = data.id;
              this.appStatus.userName = data.username;
              this.appStatus.userCompany = data.company;
              this.appStatus.userKey = sha512(data.user_key);
              if(data.img == ""){
                  this.appStatus.userImage = "assets/user.png";
              } else {
                  this.appStatus.userImage = data.img;
              }                
              this.appStatus.userPass = sha512(localStorage.DevUserPass + this.appStatus.salted);
              this.appStatus.userMail = localStorage.DevUserMail;
          }
      },
      async sessionStorageCheck(){
          let data = {mail: 0, password: 0};
          await axios.get(this.appStatus.api + '/get/login.php',{ 
              params:{ 
                  mail: sessionStorage.DevUserMail, 
                  password: sha512(sessionStorage.DevUserPass + this.appStatus.salted),
              }
              }).then(function(response){
                  if(response.data.length === 1){
                      data = response.data[0];
                  }
                  
              }).catch(function(error){ 
                  console.log(error);
              });
          if(sessionStorage.DevUserMail === data.mail && sha512(sessionStorage.DevUserPass + this.appStatus.salted) === data.password){
              this.appStatus.user = true;
              this.appStatus.db = data.db;
              this.appStatus.userId = data.id;
              this.appStatus.userName = data.username;
              this.appStatus.userCompany = data.company;
              this.appStatus.userKey = sha512(data.user_key);
              if(data.img == ""){
                  this.appStatus.userImage = "assets/user.png";
              } else {
                  this.appStatus.userImage = data.img;
              }                
              this.appStatus.userPass = sha512(sessionStorage.DevUserPass + this.appStatus.salted);
              this.appStatus.userMail = sessionStorage.DevUserMail;
          }
      },
    },
    watch:{
      appStatus: {
        handler(x){
            this.user.status = x.user;
        },
        deep: true
        },
        '$route': {
          handler: function() {
            if(localStorage.DevUser){
              console.log();
            } else if(sessionStorage.DevUser){
              console.log();
            } else{
              this.$router.push('/login');
            }
          },
          deep: true,
          immediate: true
  }
    }
}
</script>